import { dynamicLoader } from '~/utils';

export const JobsPage = dynamicLoader({
  name: 'JobsPage',
  importFunc: () => import('./jobs'),
});